import { validateLayerData } from './utils.js';
import { CONFIG } from './constants.js';
import { createDispatcher } from './dispatcher.js';
import { createClientEventHistory } from './client-history.js';

function createClientBroadcaster(_ref) {
  let {
    env = 'dev'
  } = _ref;
  const [push, send] = createDispatcher(CONFIG[env]);
  const eventHistory = createClientEventHistory({
    length: 1000
  });
  return function (data) {
    let {
      flush = false
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const event_data = validateLayerData(data, {
      debug: CONFIG[env].debug
    });

    // Prevent duplicate events from being sent
    if (eventHistory.includes(event_data)) {
      return;
    }
    eventHistory.push(event_data);
    push(event_data);
    if (flush) {
      send();
    }
  };
}

export { createClientBroadcaster };
